module.exports = __webpack_public_path__ + "static/img/person_2.7661a54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person_2.jpg
// module id = Iwuz
// module chunks = 0